// Convert fraction string to decimal
export const fractionToDecimal = (fraction) => {
  if (!fraction) return 0;
  const [num, denom] = fraction.split('/').map(Number);
  return num / denom;
};

// Calculate stake and returns based on staking method
export const calculateBetDetails = (bet, filters, bankroll = 0, kellyFraction = 1) => {
  let baseStake = 0;
  let profit = 0;

  // Convert values and get odds based on selected odds type
  const originalStake = parseFloat(bet.stake || 5.00);
  const odds = parseFloat(bet[filters.oddsType]);
  const ev = parseFloat(bet.ev_taken);
  const placeTerms = fractionToDecimal(bet.terms);
  const isBFSP = filters.oddsType === 'bfsp';

  if(odds < 1.01) {
    return {
      stake: 0,
      profit: 0
    };
  }

  // Calculate base stake
  switch (filters.stakingMethod) {
    case 'kelly':
      const edge = ev / 100 - 1;
      const kellyStake = bankroll * (edge / (odds - 1)) * (kellyFraction / 100);
      baseStake = Math.min(kellyStake, bankroll * 0.1);
      break;
      
    case 'ewkelly':
      // Use the ew_kelly_stake if available or calculate
      if (bet.ew_kelly_stake) {
        // Use pre-calculated ew_kelly_stake from the bet data
        baseStake = parseFloat(bet.ew_kelly_stake || 5.0);
        
        // Scale the stake based on user's bankroll and kelly fraction settings
        if (bankroll && kellyFraction) {
          // Default calculation uses bankroll of 10000 and kelly fraction of 0.25
          const userBankroll = parseFloat(bankroll);
          const userKellyFraction = parseFloat(kellyFraction) / 100;
          const bankrollRatio = userBankroll / 10000;
          const kellyRatio = userKellyFraction / 0.25;
          
          // Adjust the base stake proportionally
          baseStake = baseStake * bankrollRatio * kellyRatio;
        }
      } else {
        // return 0 if no ew_kelly_stake because we'd rather just not show the bet
        baseStake = 0;
      }
      break;

    case 'unitWin':
      baseStake = filters.unitWinAmount / (odds - 1);
      break;

    case 'eachwayUnitWin':
      const placeFraction = fractionToDecimal(bet.terms);
      baseStake = filters.unitWinAmount / (odds + (((odds - 1) * placeFraction) + 1) - 2);
      break;

    case 'unitLoss':
      baseStake = filters.unitLossAmount || originalStake;
      break;

    default:
      baseStake = originalStake;
  }

  // Calculate profit based on result
  if (isBFSP) {
    // For BFSP, only calculate win bet
    switch (bet.result) {
      case 'Win':
        profit = (baseStake * (odds - 1) * 0.98);
        break;
      case 'Place':
      case 'Loss':
        profit = -baseStake;
        break;
      default: // Non Runner
        profit = 0;
    }
  } else {
    // For book odds, calculate both win and place

    // console.log(`Bet details: ${bet.sel_name}`);
    switch (bet.result) {
      case 'Win':
        // Win part: full odds
        profit += baseStake * (odds - 1);
        // console.log(`Win part2: ${profit},  Odds -1: ${odds -1}`);
        // Place part: reduced odds
        profit += baseStake * ((odds - 1) * placeTerms);
        // console.log(`Win part2: ${profit}, Place terms: ${placeTerms}, Odds: ${odds}`);
        break;

      case 'Place':
        // Lose win part
        profit -= baseStake;
        // Place part pays at reduced odds
        profit += baseStake * ((odds - 1) * placeTerms);
        break;

      case 'Loss':
        // Lose both stakes
        profit = -(baseStake * 2);
        break;

      default: // Non Runner
        profit = 0;
    }
  }

  return { 
    stake: isBFSP ? baseStake : baseStake * 2,
    profit
  };
}; 